import { render, staticRenderFns } from "./Screen.vue?vue&type=template&id=fc0cfa5a&scoped=true"
import script from "./Screen.vue?vue&type=script&lang=js"
export * from "./Screen.vue?vue&type=script&lang=js"
import style0 from "./Screen.vue?vue&type=style&index=0&id=fc0cfa5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../imported/work/site/src/project/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0cfa5a",
  null
  
)

export default component.exports